import { styled } from '@mui/material/styles';

const Heading = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1),
    color: '#000',
    fontSize: 'calc(10px + 1vmin)',
    fontWeight: '600',
    width: '100%',
    marginTop: 8,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: 6
}));

export default Heading;